import { cn } from '~/lib/utils';
import { Button } from '~/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~/components/ui/card';
import { Input } from '~/components/ui/input';
import { Label } from '~/components/ui/label';
import React from 'react';
import { useGlobalState } from '~/context/GlobalStateContext';

export const Login = () => {
  return (
    <div className='flex min-h-svh w-full items-center justify-center p-6 md:p-10'>
      <div className='w-full max-w-sm'>
        <LoginForm />
      </div>
    </div>
  );
};

export function LoginForm({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  const { signIn } = useGlobalState();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);

  const submit = async () => {
    if (email.trim().length && password.trim().length) {
      setIsLoading(true);
      try {
        const res = await signIn({
          email: email.trim(),
          password: password.trim(),
        });
        const user = res.data.user;
        if (!user) {
          setError('Authentication Failed');
        } else {
          setError('');
        }
        setIsLoading(false);
      } catch (error) {
        // console.log(error);
      }
    }
  };
  return (
    <div className={cn('flex flex-col gap-6', className)} {...props}>
      <Card>
        <CardHeader>
          <CardTitle>Login to your account</CardTitle>
          <CardDescription>
            Enter your email below to login to your account
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div>
            <div className='flex flex-col gap-6'>
              <div className='grid gap-3'>
                <Label htmlFor='email'>Email</Label>
                <Input
                  id='email'
                  type='email'
                  placeholder='m@example.com'
                  value={email}
                  onInput={(e) => setEmail(e.currentTarget.value)}
                  required
                />
              </div>
              <div className='grid gap-3'>
                <div className='flex items-center'>
                  <Label htmlFor='password'>Password</Label>
                </div>
                <Input
                  id='password'
                  type='password'
                  required
                  value={password}
                  onInput={(e) => setPassword(e.currentTarget.value)}
                />
              </div>

              {error && <span className='text-red-800'>{error}</span>}
              <div className='flex flex-col gap-3'>
                <Button onClick={submit} className='w-full'>
                  {isLoading && <span>Loading...</span>}
                  {!isLoading && <span>Login</span>}
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
